import React, { useState } from "react";
import Internship_Program_Card from "../../../../../common_components/common-cards/internship-program-card/Internship_Program_Card";
import Internship_Program_Details from "../../../../../common_components/common-cards/internship-program-details/Internship_Program_Details";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { IDS } from "../../../../../../utils/IDS";

const Internship_Program = ({
  isMyApplications = false,
  onShowDetails,
  onBackToList,
}) => {
  const [selectedProgram, setSelectedProgram] = useState(null);

  const internships =
    useSelector((state) => state.studentapplication.hotelapplications?.data) ||
    [];

  const formatDate = (date) => {
    if (!date) return "-";
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // const internships = [
  //   {
  //     companyLogo:
  //       "/assets/images/common-card/internship-program/internship-logo.png",
  //     companyTitle: "Ritz Paris",
  //     countryFlag: "/assets/images/common-card/study-program/flag-2.png",
  //     title: "Sous Chef",
  //     description:
  //       "Train as a professional Sous Chef with hands-on experience in international kitchens & mentorship from expert chefs abroad.",
  //     image: "/assets/images/common-card/internship-program/internship-img.png",
  //     details: {
  //       start: "20-05-2025",
  //       end: "20-10-2025",
  //       hours: "48 Hrs/week",
  //     },
  //     benefits: {
  //       meals: "Yes",
  //       uniform: "Yes",
  //       laundry: "No",
  //       accommodation: "Single Room",
  //     },
  //     requirements: {
  //       french: "C1",
  //       english: "B1",
  //     },
  //     documents: ["FR Language CV", "Portfolio"],
  //     stipend: "€1,000/month",
  //     status: "under_review",
  //   },

  //   // {
  //   //   companyLogo:
  //   //     "/assets/images/common-card/internship-program/internship-logo.png",
  //   //   companyTitle: "Ritz Paris",
  //   //   countryFlag: "/assets/images/common-card/study-program/flag-2.png",
  //   //   title: "Sous Chef",
  //   //   description:
  //   //     "Train as a professional Sous Chef with hands-on experience in international kitchens & mentorship from expert chefs abroad.",
  //   //   image: "/assets/images/common-card/internship-program/internship-img.png",
  //   //   details: {
  //   //     start: "20-05-2025",
  //   //     end: "20-10-2025",
  //   //     hours: "48 Hrs/week",
  //   //   },
  //   //   benefits: {
  //   //     meals: "Yes",
  //   //     uniform: "Yes",
  //   //     laundry: "No",
  //   //     accommodation: "Single Room",
  //   //   },
  //   //   requirements: {
  //   //     french: "C1",
  //   //     english: "B1",
  //   //   },
  //   //   documents: ["FR Language CV", "Portfolio"],
  //   //   stipend: "€1,000/month",
  //   //   status: "under_review",
  //   // },

  //   // {
  //   //   companyLogo:
  //   //     "/assets/images/common-card/internship-program/internship-logo.png",
  //   //   companyTitle: "Ritz Paris",
  //   //   countryFlag: "/assets/images/common-card/study-program/flag-2.png",
  //   //   title: "Sous Chef",
  //   //   description:
  //   //     "Train as a professional Sous Chef with hands-on experience in international kitchens & mentorship from expert chefs abroad.",
  //   //   image: "/assets/images/common-card/internship-program/internship-img.png",
  //   //   details: {
  //   //     start: "20-05-2025",
  //   //     end: "20-10-2025",
  //   //     hours: "48 Hrs/week",
  //   //   },
  //   //   benefits: {
  //   //     meals: "Yes",
  //   //     uniform: "Yes",
  //   //     laundry: "No",
  //   //     accommodation: "Single Room",
  //   //   },
  //   //   requirements: {
  //   //     french: "C1",
  //   //     english: "B1",
  //   //   },
  //   //   documents: ["FR Language CV", "Portfolio"],
  //   //   stipend: "€1,000/month",
  //   //   status: "under_review",
  //   // },
  //   // {
  //   //   companyLogo:
  //   //     "/assets/images/common-card/internship-program/internship-logo.png",
  //   //   companyTitle: "Ritz Paris",
  //   //   countryFlag: "/assets/images/common-card/study-program/flag-2.png",
  //   //   title: "Sous Chef",
  //   //   description:
  //   //     "Train as a professional Sous Chef with hands-on experience in international kitchens & mentorship from expert chefs abroad.",
  //   //   image: "/assets/images/common-card/internship-program/internship-img.png",
  //   //   details: {
  //   //     start: "20-05-2025",
  //   //     end: "20-10-2025",
  //   //     hours: "48 Hrs/week",
  //   //   },
  //   //   benefits: {
  //   //     meals: "Yes",
  //   //     uniform: "Yes",
  //   //     laundry: "No",
  //   //     accommodation: "Single Room",
  //   //   },
  //   //   requirements: {
  //   //     french: "C1",
  //   //     english: "B1",
  //   //   },
  //   //   documents: ["FR Language CV", "Portfolio"],
  //   //   stipend: "€1,000/month",
  //   //   status: "under_review",
  //   // },
  //   // {
  //   //   companyLogo:
  //   //     "/assets/images/common-card/internship-program/internship-logo.png",
  //   //   companyTitle: "Ritz Paris",
  //   //   countryFlag: "/assets/images/common-card/study-program/flag-2.png",
  //   //   title: "Sous Chef",
  //   //   description:
  //   //     "Train as a professional Sous Chef with hands-on experience in international kitchens & mentorship from expert chefs abroad.",
  //   //   image: "/assets/images/common-card/internship-program/internship-img.png",
  //   //   details: {
  //   //     start: "20-05-2025",
  //   //     end: "20-10-2025",
  //   //     hours: "48 Hrs/week",
  //   //   },
  //   //   benefits: {
  //   //     meals: "Yes",
  //   //     uniform: "Yes",
  //   //     laundry: "No",
  //   //     accommodation: "Single Room",
  //   //   },
  //   //   requirements: {
  //   //     french: "C1",
  //   //     english: "B1",
  //   //   },
  //   //   documents: ["FR Language CV", "Portfolio"],
  //   //   stipend: "€1,000/month",
  //   //   status: "under_review",
  //   // },
  //   // {
  //   //   companyLogo:
  //   //     "/assets/images/common-card/internship-program/internship-logo.png",
  //   //   companyTitle: "Ritz Paris",
  //   //   countryFlag: "/assets/images/common-card/study-program/flag-2.png",
  //   //   title: "Sous Chef",
  //   //   description:
  //   //     "Train as a professional Sous Chef with hands-on experience in international kitchens & mentorship from expert chefs abroad.",
  //   //   image: "/assets/images/common-card/internship-program/internship-img.png",
  //   //   details: {
  //   //     start: "20-05-2025",
  //   //     end: "20-10-2025",
  //   //     hours: "48 Hrs/week",
  //   //   },
  //   //   benefits: {
  //   //     meals: "Yes",
  //   //     uniform: "Yes",
  //   //     laundry: "No",
  //   //     accommodation: "Single Room",
  //   //   },
  //   //   requirements: {
  //   //     french: "C1",
  //   //     english: "B1",
  //   //   },
  //   //   documents: ["FR Language CV", "Portfolio"],
  //   //   stipend: "€1,000/month",
  //   //   status: "under_review",
  //   // },
  // ];

  /* ================= HANDLERS ================= */

  // const handleViewDetails = (program) => {
  //   setSelectedProgram(program);
  //   onShowDetails?.();
  // };

  const handleViewDetails = (program) => {
    const mappedDetailData = {
      logo: IDS.IMG_URL + program.logo,
      companyName: program.name,
      location: `${program.street}, ${program.city}, ${program.country}`,
      flag: IDS.IMG_URL + program.country_logo,
      bannerImage: IDS.IMG_URL + program.image,

      title: program.title,
      description: program.description,

      startDate: new Date(program.start_date).toLocaleDateString(),
      endDate: new Date(program.end_date).toLocaleDateString(),
      workHours: program.work_hour,
      vacancies: program.vacancy,

      benefits: [
        {
          label: "Meals Provided",
          value: program.meal_provided ? "Yes" : "No",
        },
        {
          label: "Uniform Provided",
          value: program.uniform_provided ? "Yes" : "No",
        },
        {
          label: "Laundry Service",
          value: program.laundry_service ? "Yes" : "No",
        },
        {
          label: "Accommodation",
          value: program.accomodation_status
            ? `${program.street}, ${program.postal_code}, ${program.city}, ${program.country}`
            : "No",
        },
      ],

      requirements: program.Internship_Requirements?.map(
        (r) => r.Requirement?.name
      ),

      documents: program.Internship_Documents?.map((d) => d.Document?.name),

      contacts: program.Internship_Contacts || [],

      stipend: `€${program.stipend}`,
    };

    setSelectedProgram(mappedDetailData);
    onShowDetails?.();
  };

  const handleBack = () => {
    setSelectedProgram(null);
    onBackToList?.();
  };

  /* ================= DETAIL VIEW ================= */

  if (selectedProgram) {
    return (
      <Internship_Program_Details data={selectedProgram} onBack={handleBack} />
    );
  }

  /* ================= LIST VIEW ================= */

  return (
    <div className="">
      <Row className="g-4 mt-4">
        {internships.map((item, index) => (
          <Col key={item.id} lg={4} md={6} sm={12}>
            {/* <Internship_Program_Card
              companyLogo={IDS.IMG_URL + item.logo}
              companyTitle={item.name}
              image={IDS.IMG_URL + item.image}
              countryFlag={IDS.IMG_URL + item.country_logo}
              title={item.title}
              description={item.description}
              showBadge={isMyApplications}
              status={item.Accept_Reject_Status?.name}
              onViewDetails={() => handleViewDetails(item)}
            /> */}
            <Internship_Program_Card
              companyLogo={IDS.IMG_URL + item.logo}
              companyTitle={item.name}
              image={IDS.IMG_URL + item.image}
              countryFlag={IDS.IMG_URL + item.country_logo}
              title={item.title}
              description={item.description}
              details={{
                start: formatDate(item.start_date),
                end: formatDate(item.end_date),
                hours: item.work_hour
                  ? `${item.work_hour.split(":")[0]} Hrs/week`
                  : "-",
              }}
              benefits={{
                meals: item.meal_provided ? "Yes" : "No",
                uniform: item.uniform_provided ? "Yes" : "No",
                laundry: item.laundry_service ? "Yes" : "No",
                accommodation: item.accomodation_status ? "Yes" : "No",
              }}
              requirements={{
                french:
                  item.Internship_Requirements?.find(
                    (r) => r.Requirement?.name === "French"
                  )?.level || "N/A",
                english:
                  item.Internship_Requirements?.find(
                    (r) => r.Requirement?.name === "English"
                  )?.level || "N/A",
              }}
              documents={
                item.Internship_Documents?.map((d) => d.Document?.name) || []
              }
              showBadge={isMyApplications}
              status={item.Accept_Reject_Status?.name}
              onViewDetails={() => handleViewDetails(item)}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default Internship_Program;
